<template>
   <Suspense>
      <div>
         <component :is="$route.meta.layoutComponent">
            <slot />
         </component>
      </div>
   </Suspense>
</template>

<script>
export default {
   name: "AppLayout",
}
</script>
